import script from "./wind-layer-toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./wind-layer-toggle.vue?vue&type=script&setup=true&lang=ts"

import "./wind-layer-toggle.vue?vue&type=style&index=0&id=4c74c8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c74c8e4"]])

export default __exports__